import * as THREE from 'three'
import Experience from "../Experience"

export default class FishingBoat {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        // Debug
        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder('fish')
        // }

        // Setup
        this.resource = this.resources.items.fishingBoatModel

        this.setModel()
        // this.setTextures()
        // this.setAnimation()
        // this.setMaterial()

        // Bind the method to the instance, otherwise the eventlistener uses the DOM element to look for the method which is wrong
        // this.switchAnimation = this.switchAnimation.bind(this)

        // this.addEventListeners()

    }

    // Check if hotspot is clicked
    addEventListeners() {
        // window.addEventListener('click', (event) => document.querySelectorAll('.point-fish')[0].switchAnimation(), false);
        // document.querySelectorAll('.point-fish')[0].addEventListener('click', this.switchAnimation)
        // document.querySelectorAll('.point-fish')[0].parentElement.querySelector('.close').addEventListener('click', this.switchAnimation)
    }

    setModel() {

        this.model = this.resource.scene
        this.model.position.set(2, 0, 3.7)
        this.model.scale.set(0.08, 0.08, 0.08)
        // Scale and rotation influences the tracked hotspot
        // this.model.children[0].scale.set(1.2, 1.2, 1.2)
        this.model.rotation.set(0, Math.PI * 2.5, 0)
        // this.model.position.set(100, 100, 100)
        this.scene.add(this.model)

        // console.log(this.model)


        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.receiveShadow = true
                child.castShadow = true
                child.renderOrder = 4
            }
        })
    }

    setMaterial() {
        let m = this.model.children[0].material

        if (m) {
            m.dispose()
        }

        // m.visible = false
        m = new THREE.MeshStandardMaterial({
            color: 0xffffff,
            envMap: null,
            map: null,
        })
        m.needsUpdate = true;
    }
    // setTextures() {
    //     this.textures = {}
    //     this.textures.color = this.resources.items.fishTexture
    //     this.textures.color.colorSpace = THREE.SRGBColorSpace
    //     this.textures.color.repeat.set(1.5, 1.5)
    //     this.textures.color.wrapS = THREE.RepeatWrapping
    //     this.textures.color.wrapT = THREE.RepeatWrapping

    //     this.textures.normal = this.resources.items.grassNormalTexture
    //     this.textures.normal.repeat.set(1.5, 1.5)
    //     this.textures.normal.wrapS = THREE.RepeatWrapping
    //     this.textures.normal.wrapT = THREE.RepeatWrapping
    // }

    setAnimation() {
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer(this.model)

        this.animation.actions = {}

        // console.log("Heyo: " + this.model)
        // console.log("Heyo: " + this.resources.items);

        this.animation.actions.path = this.animation.mixer.clipAction(this.resource.animations[0])

        // console.log(this.animation.actions.path)
        // this.animation.actions.swim = this.animation.mixer.clipAction(this.resource.animations[1])
        // this.animation.actions.joel = this.animation.mixer.clipAction(this.resource.animations[2])

        this.animation.actions.current = this.animation.actions.path
        this.animation.actions.current.play()
        this.animation.actions.current.time = 50 // 3050 is over the fish
        // this.isAnimating = true
        // this.animation.actions.swim.play()

        // console.log(this.resource.animations)
        // if (this.experience.changeAnimation.animate(clicked)) {
        //     this.animation.actions.current = this.animation.actions.rotate
        // }

        // You can fade, crossfade, etc. between the animation (cool)
        // You can test that by using the console, window.experience.world.fox.animation.play('walking')
        // this.animation.play = (name) => {
        //     const newAction = this.animation.actions[name]
        //     const oldAction = this.animation.actions.current

        //     newAction.reset()
        //     newAction.play()
        //     newAction.crossFadeFrom(oldAction, 1)

        //     this.animation.actions.current = newAction
        // }

        // // Debug
        // if (this.debug.active) {
        //     const debugObject = {
        //         playIdle: () => { this.animation.play('idle') },
        //         playWalking: () => { this.animation.play('walking') },
        //         playRunning: () => { this.animation.play('running') }
        //     }

        //     this.debugFolder.add(debugObject, 'playIdle')
        //     this.debugFolder.add(debugObject, 'playWalking')
        //     this.debugFolder.add(debugObject, 'playRunning')
        // }
    }

    // Cycling animations
    // switchAnimation() {
    //     const animations = Object.values(this.animation.actions); // In this case it's 3
    //     const currentActionIndex = animations.indexOf(this.animation.actions.current); // Starts at 0 immediately

    //     // Determine the next action
    //     let nextAction;
    //     console.log(currentActionIndex)

    //     if (currentActionIndex === animations.length - 2) { // Because 0 already starts, we have 1 and 2 left. Except when you click, it already goes to 1. So -2 here.
    //         // If the last animation is reached, go back to the first animation
    //         nextAction = animations[0];

    //     } else {
    //         // Otherwise, go to the next animation in the array
    //         nextAction = animations[currentActionIndex + 1];

    //     }

    //     // Reset and play the next action, with a crossfade from the current action
    //     nextAction.reset();
    //     nextAction.play();
    //     nextAction.crossFadeFrom(this.animation.actions.current, 1);

    //     // Update the current action to the new one
    //     this.animation.actions.current = nextAction;
    // }

    // On/off
    // switchAnimation() {
    //     const currentAction = this.animation.actions.current;
    //     const duration = 1000; // Duration of the transition in milliseconds
    //     const startTime = this.time.elapsed;
    //     const initialRate = currentAction.timeScale; // Capture the current playback rate, should be 1 on the first click

    //     const updateRate = () => {
    //         const elapsedTime = this.time.elapsed - startTime;
    //         const progress = Math.min(elapsedTime / duration, 1);

    //         if (this.isAnimating) {
    //             // If the animation is currently running, decrease the rate to 0
    //             currentAction.timeScale = initialRate - initialRate * progress;

    //             if (progress >= 1) {
    //                 currentAction.paused = true; // Pause the animation when fully slowed down
    //                 this.isAnimating = false; // Toggle state to paused
    //                 // console.log(this.model.children[1].position)

    //             }
    //         } else {
    //             // If the animation is paused, increase the rate to 1
    //             currentAction.paused = false; // Immediately unpause
    //             currentAction.timeScale = initialRate + (1 - initialRate) * progress;

    //             if (progress >= 1) {
    //                 this.isAnimating = true; // Toggle state to playing
    //             }
    //         }

    //         if (progress < 1) {
    //             requestAnimationFrame(updateRate); // Continue updating until the duration completes
    //         }
    //     };

    //     requestAnimationFrame(updateRate);
    // }


    update() {

        this.animation.mixer.update(this.time.delta / 2000) // Divide by 1000 because it's in milliseconds
    }
}